import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showFields: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.show-fields',
		defaultMessage: 'Show fields',
		description: 'Label for show fields menu item in issue-create modal header',
	},
	findField: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.find-field',
		defaultMessage: 'Find your field',
		description: 'Label for find field menu item in issue-create modal header',
	},
	moreActions: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions',
		defaultMessage: 'More actions for this issue',
		description: 'Aria-label for more actions button in issue-create modal',
	},
});
